module.exports = __webpack_public_path__ + "static/cartier-c03f21367fb3b4672da1829e900199f4.jpg";